"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getColumnNameQuery", {
    enumerable: true,
    get: function() {
        return getColumnNameQuery;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _generateLookupSelectQuery = /*#__PURE__*/ _interop_require_default(require("~/db/generateLookupSelectQuery"));
const _genRollupSelectv2 = /*#__PURE__*/ _interop_require_default(require("~/db/genRollupSelectv2"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getColumnNameQuery({ baseModelSqlv2, column, context }) {
    // If the column is a barcode or qr code column, we fetch the column that the virtual column refers to.
    if (column.uidt === _nocodbsdk.UITypes.Barcode || column.uidt === _nocodbsdk.UITypes.QrCode) {
        column = new _models.Column(_extends({}, await column.getColOptions(context).then((col)=>col.getValueColumn(context)), {
            id: column.id
        }));
    }
    let column_name_query = column.column_name;
    if (column.uidt === _nocodbsdk.UITypes.CreatedTime && !column.column_name) column_name_query = 'created_at';
    if (column.uidt === _nocodbsdk.UITypes.LastModifiedTime && !column.column_name) column_name_query = 'updated_at';
    if (column.uidt === _nocodbsdk.UITypes.CreatedBy && !column.column_name) column_name_query = 'created_by';
    if (column.uidt === _nocodbsdk.UITypes.LastModifiedBy && !column.column_name) column_name_query = 'updated_by';
    /* The following column types require special handling:
   * - Links
   * - Rollup
   * - Formula
   * - Lookup
   * - LinkToAnotherRecord
   * These column types require special handling because they are virtual columns and do not have a direct column name.
   * We generate the select query for these columns and use the generated query.
   * */ switch(column.uidt){
        case _nocodbsdk.UITypes.Links:
        case _nocodbsdk.UITypes.Rollup:
            {
                const knex = baseModelSqlv2.dbDriver;
                column_name_query = await (0, _genRollupSelectv2.default)({
                    baseModelSqlv2,
                    knex,
                    columnOptions: await column.getColOptions(context)
                });
                break;
            }
        case _nocodbsdk.UITypes.Formula:
            {
                const formula = await column.getColOptions(context);
                if (!formula.error) {
                    column_name_query = await baseModelSqlv2.getSelectQueryBuilderForFormula(column);
                }
                break;
            }
        case _nocodbsdk.UITypes.LinkToAnotherRecord:
        case _nocodbsdk.UITypes.Lookup:
            {
                const model = await column.getModel(context);
                column_name_query = await (0, _generateLookupSelectQuery.default)({
                    baseModelSqlv2,
                    column: column,
                    alias: null,
                    model,
                    isAggregation: true
                });
                break;
            }
        case _nocodbsdk.UITypes.Checkbox:
            {
                column_name_query = {
                    builder: baseModelSqlv2.dbDriver.raw(`COALESCE(??, false)`, [
                        column_name_query
                    ])
                };
            }
    }
    return typeof column_name_query === 'string' ? {
        builder: column_name_query
    } : column_name_query;
}
